import WrappedLink from './wrapped-link';
import Link from 'next/link';
import { primaryNav, secondaryNav } from '../data/nav';
import MobileNav from '../../lib/components/mobile-nav';

const CrHomepageNav = ({ linkHighlight }) => {
  return (
    <header id="site-header" role="banner">
      <WrappedLink className="skip-link sr-only" href="#site-main">
        Skip to content
      </WrappedLink>
      <div className="container-xl">
        <MobileNav />
        <Link passHref aria-label="College Recruiter" href="/">
          <a className="logo">
            <span className="sr-only">College Recruiter</span>
          </a>
        </Link>
        <div className="nav-container-top">
          <nav id="primary-nav">
            <ul>
              {primaryNav.map((p, i) => {
                return (
                  <li key={i} className={linkHighlight == p.linkID ? 'current' : ''}>
                    <Link passHref href={p.url}>
                      {p.linkText}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>

          <nav id="secondary-nav">
            <ul>
              {secondaryNav.map((p, i) => {
                return (
                  <li key={i} className={linkHighlight == p.linkID ? 'current' : ''}>
                    <WrappedLink href={p.url}>{p.linkText}</WrappedLink>
                  </li>
                );
              })}
            </ul>
            {/* MOBILE NAV TOGGLE BUTTON */}
            {/* <button
              onClick={toggleMobileNav}
              className="navbar-toggler search-toggler fa-regular fa-magnifying-glass"
              type="button"
              data-toggle="collapse"
              data-target="#cr-navbar"
              aria-controls="cr-navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Search Toggle</span>
            </button> */}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default CrHomepageNav;
